import { Matrix4 } from 'three';

import { Isometry } from '@paragon/geometry-library';

import { newVector3 } from './newVector3';

export function getMatrixFromIsometry(embedding: Isometry): Matrix4 {
  const xAxisVector = newVector3(embedding.xAxis);
  const yAxisVector = newVector3(embedding.yAxis);
  const zAxisVector = newVector3(embedding.zAxis);
  const wVector = newVector3(embedding.origin);

  return new Matrix4().makeBasis(xAxisVector, yAxisVector, zAxisVector).setPosition(wVector);
}
